import { doPost, toUrl } from "./lib.js";
import { receiveLabelPropertyValues, receiveLabelProperties, receivePeople, } from "./schemas.js";
export async function labelProperties(clientInfo, _input) {
    const url = toUrl(clientInfo.orgId, "completion/label-properties");
    const json = await doPost(url, clientInfo, {});
    return receiveLabelProperties().parse(json);
}
export async function labelPropertyValues(clientInfo, input) {
    const url = toUrl(clientInfo.orgId, "completion/values");
    const json = await doPost(url, clientInfo, input);
    return receiveLabelPropertyValues().parse(json);
}
export async function people(clientInfo, _input) {
    const url = toUrl(clientInfo.orgId, "completion/people");
    const json = await doPost(url, clientInfo, {});
    return receivePeople().parse(json);
}
